<template>

    <div class="search" :class="{'active': search != ''}">
      <input v-if="isHome" class="input" v-model="search" v-on:keyup.enter="doSearch()" :placeholder="$t('general.search_piece')" />
      <input v-else class="input" v-model="search" v-on:keyup.enter="doSearch()" />
      <div class="icon" @click="doSearch()" v-on:click.stop></div>
    </div>

</template>

<script>


export default {
  name: 'Searcher',
  props: {string: String, refresh: Boolean, isHome: Boolean},
  data () {
    return {
      search: this.string,
    }
  },
  computed: {
      // search: {
      //     get: function(){ return this.string }, 
      //     set: function( string ){ this.string = string }
      // }
  },
  methods: {
    doSearch() {
      if(this.search != '') {
        //this.$store.commit('setSearch', this.search);
        //this.$router.replace( {name: 'search' } );
        this.$overlay.loading();
        var self = this;
        var search = this.search;
        this.$store.dispatch('files/searchFiles', {search: search}).then(function() {
            self.$store.commit('setLoading', false);
            self.$router.push({ name: 'search', query: {s: search }});
            self.$overlay.hide();
        });
        
        // if(this.refresh) this.search = '';
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .search {
    display: block;
    overflow: hidden;
    margin-top: 10px;
    -webkit-transition: all 1s;
    transition: all 1s;

    .input {
      border: none;
      border-bottom: 2px solid #ccc;
      padding: 5px;
      outline: none;
      background: url('/img/magnify.svg') no-repeat right 5px center;
      background-size: 20px;
      width: 100%;
      float: left;
    }
    .icon {
      display: none;
      cursor: pointer;
      width: 30px;
      height: 30px;
      background: url('/img/go.svg') no-repeat center var(--main_color);
      background-size: 20px;
      border-radius: 3px;
      margin-left: 10px;
    }
    
    &.active {
      .input {
        width: calc( 100% - 40px );
        background: transparent;
      }
      .icon {
        display: inline-block;
      }
    }

  }

</style>
